module.exports = __webpack_public_path__ + "static/media/docx_icon.4b70b9ec.svg";